import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import FranchiseeAliasBanner from '../../components/FranchiseeAliasBanner/FranchiseeAliasBanner';
import FullScreenLoading from '../../components/FullScreenLoading/FullScreenLoading';
import GlobalFreezeBanner from '../../components/GlobalFreezeBanner/GlobalFreezeBanner';
import ConfirmationModal from '../../components/Modal/ConfirmationModal/ConfirmationModal';
import Navigation from '../../components/Navigation/Navigation';
import { useActiveGlobalFreezes } from '../../services/freeze/freeze.service';
import { useCurrentUser } from '../../services/user/user.service';
import { FRANCHISEE_IMPERSONATION, LOGIN_ID_HEADER, ORG_ID_HEADER, UserTypes } from '../../types/auth.types';
import useConfirmationModal from '../../utils/useConfirmationModal/useConfirmationModal';
import useFranchiseeAlias from '../../utils/useFranchiseeAlias/useFranchiseeAlias';
import styles from './WithAuth.module.css';
import { useSTKContext } from '@/context/context';
import classNames from 'classnames';

const WithAuth: FC = () => {
  const { data: activeGlobalFreezeData } = useActiveGlobalFreezes(true);
  const freezeExists = activeGlobalFreezeData?.data && activeGlobalFreezeData?.data?.length > 0;
  const { data } = useCurrentUser(true);
  const isAdminUser = data?.data.type === UserTypes.ADMIN;
  const { alias } = useFranchiseeAlias();
  const { isOpen, close, title, hideStatusUpdateText } = useConfirmationModal();
  const { apiClient } = useSTKContext();
  apiClient.defaults.headers.common[ORG_ID_HEADER] = alias?.orgId;
  apiClient.defaults.headers.common[LOGIN_ID_HEADER] = alias?.loginId || FRANCHISEE_IMPERSONATION;

  const aliasing = alias !== null;
  if (data?.data.orgId) {
    return (
      <div className={styles.pageLayout}>
        <Navigation isAdmin={data?.data.type === UserTypes.ADMIN} />
        <main
          id="main"
          className={classNames(styles.adminMain, {
            [styles.adminOff]: isAdminUser,
            [styles.adminOnAlias]: aliasing,
          })}
        >
          {aliasing && <FranchiseeAliasBanner />}
          {freezeExists && !isAdminUser && <GlobalFreezeBanner {...activeGlobalFreezeData?.data[0]} />}
          <Outlet />
        </main>
        <ConfirmationModal
          isOpen={isOpen}
          onClose={close}
          title={`${title}`}
          hideStatusUpdateText={hideStatusUpdateText}
        />
      </div>
    );
  }
  return <FullScreenLoading />;
};

export default WithAuth;
